<!--
Copyright 2025 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="sub-container d-flex gap-5 justify-content-center">
  <app-collection-membership-list [users]="nonMembers$ | async" [groups]="groupNonMembers$ | async"
    [canEdit]="canEdit$ | async" (createMembership)="createMembership($event)"></app-collection-membership-list>

  <app-collection-member-list [memberships]="memberships$ | async" [users]="members$ | async"
    [groups]="groupMembers$ | async" [roles]="roles$ | async" [canEdit]="canEdit$ | async"
    (deleteMembership)="deleteMembership($event)"
    (editMembership)="editMembership($event)"></app-collection-member-list>
</div>
